module.exports = __webpack_public_path__ + "static/media/gioweb2_logo_mini.f5478058.svg";